import { useEffect } from 'react';
import { Card } from '../ui/Card.jsx';
import { Button } from '../ui/Button.jsx';
import { useAudio } from '../../hooks/useAudio.js';

export function CombatCard({ result, onContinue }) {
  const audio = useAudio();
  const { raidStrength, defense, won, damage, losses, surprise, surplus } = result;

  // Play combat sounds
  useEffect(() => {
    if (result) {
      audio.playSound('combat_warcry');

      // Play victory/defeat sound after a brief delay
      const timer = setTimeout(() => {
        audio.playSound(won ? 'music_jingle_positive' : 'ui_negative');
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [result, won, audio]);

  return (
    <Card title="Raid!" icon="⚔️">
      <div className="text-center mb-6">
        {surprise && (
          <div className="text-red-700 font-bold text-sm mb-3 bg-red-100 border border-red-400 rounded p-2">
            ⚡ Surprise Attack! (+2 raid strength)
          </div>
        )}
        <div className="flex justify-around mb-4">
          <div>
            <div className="text-3xl mb-1">🏴</div>
            <div className="text-sm text-amber-700">Raiders</div>
            <div className="text-2xl font-bold text-red-700">{raidStrength}</div>
          </div>
          <div className="text-3xl self-center">⚔️</div>
          <div>
            <div className="text-3xl mb-1">🛡️</div>
            <div className="text-sm text-amber-700">Defense</div>
            <div className="text-2xl font-bold text-green-700">{defense}</div>
          </div>
        </div>
        <div className={`text-xl font-bold ${won ? 'text-green-700' : 'text-red-700'}`}>
          {won ? `✨ Raiders Repelled!${surplus > 0 ? ` (won by ${surplus})` : ''}` : `💥 ${damage} damage!`}
        </div>
        {!won && losses && (
          <p className="text-amber-700 mt-2">
            Lost: {losses.food > 0 && `${losses.food} food `}
            {losses.wood > 0 && `${losses.wood} wood `}
            {losses.stone > 0 && `${losses.stone} stone `}
            {(losses.workersInjured || losses.workerInjured) > 0 && `⚠️ ${losses.workersInjured || 1} worker(s) injured! `}
            {losses.workersKilled > 0 && `💀 ${losses.workersKilled} worker(s) killed! `}
          </p>
        )}
      </div>
      <div className="text-center">
        <Button onClick={onContinue}>Continue</Button>
      </div>
    </Card>
  );
}
